import React from "react";
import ArnavutkoySidebar from "../Sidebar/ArnavutkoySidebar";
import ArnavutkoyOtherServices from "../ServiceAreas/ArnavutkoyServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const ArnavutkoyIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        ARNAVUTKÖY HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Arnavutköy, geniş yerleşim alanları ve kalabalık hane yapısıyla profesyonel temizlik
            hizmetlerine olan ihtiyacın yoğun olduğu bir ilçedir. Gelişmiş teknolojimiz ve deneyimli
            personelimiz ile Arnavutköy halkına özel halı, koltuk, yorgan ve perde yıkama hizmetleri
            sunuyoruz. Ücretsiz alım-teslim ve antibakteriyel temizlik standartlarımızla yaşam alanlarınızı
            hijyenle buluşturuyoruz.
          </p>

          <p>
            Halılarınızın türüne uygun olarak uygulanan özel yıkama tekniklerimiz sayesinde renkler
            solmaz, dokular zarar görmez. Koltuk yıkama işlemlerimizde ise kumaş türüne özel şampuan ve
            buharlı sistemler kullanılmaktadır. Tüm temizlik işlemleri insan sağlığına zarar vermeyen
            organik temizlik ürünleriyle gerçekleştirilir.
          </p>

          <p>
            <strong>Arnavutköy'de sunduğumuz hizmet avantajlarımız:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Ücretsiz servis: Hadımköy, Deliklikaya, Bolluca, Haraççı gibi mahallelerde aynı gün içinde alım</li>
            <li>Fabrikada yıkama ve yerinde koltuk yıkama seçenekleri</li>
            <li>Leke çıkarma garantili hizmet</li>
            <li>Yorgan, battaniye ve perde yıkama hizmeti</li>
            <li>Toz alma, durulama ve kurutma işlemlerinde tam otomatik sistemler</li>
            <li>Hızlı teslimat: 48 saat içinde kapınızda</li>
          </ul>

          <p>
            Yıkama süreci, ön analiz ile başlar. Halı türü belirlenir, ön toz alma yapılır, ardından uygun
            programla yıkama ve kurutma sağlanır. Koltuk yıkama işlemi ise evinizde buharlı cihazlar ve
            vakum makineleriyle yapılır. Kumaşın derinliklerine kadar inen temizlik sağlanır.
          </p>

          <p>
            Tüm süreç boyunca hijyen ve müşteri memnuniyeti önceliğimizdir. Arnavutköy’de halı ve koltuk
            yıkama denildiğinde ilk akla gelen firmalardan biri olmaktan gurur duyuyoruz.
          </p>

          <p>
            Sipariş vermek, bilgi almak ya da hizmet detaylarımızı öğrenmek için bize web sitemiz ya da
            iletişim kanallarımız üzerinden ulaşabilirsiniz. Sağlıklı ve hijyenik yaşam alanları için
            doğru adrestesiniz.
          </p>

          {/* Mahalle ve diğer hizmet alanları */}
          <ArnavutkoySidebar />
          <ArnavutkoyOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default ArnavutkoyIntro;
